import type { Component } from "svelte";
import IconCompass from '~icons/mdi/compass';
import IconStarFourPoints from '~icons/mdi/star-four-points';
import IconThumbUp from '~icons/mdi/thumb-up';

export enum Importance {
    OPTIONAL = 'OPTIONAL',
    RECOMMENDED = 'RECOMMENDED',
    ESSENTIAL = 'ESSENTIAL',
}

export const IMPORTANCE_ICONS: Record<Importance, Component> = {
    [Importance.OPTIONAL]: IconCompass,
    [Importance.RECOMMENDED]: IconThumbUp,
    [Importance.ESSENTIAL]: IconStarFourPoints,
};
